<template>
    <div >
        <Card>

            <Row type="flex" justify="start" align="middle" class="code-row-bg">
                <Col span="10">
                    {{ payment.receivable.marking_minified.markingheadercode }}
                    <hr>
                    {{ payment.paymentDate | dateFormatted }}
                    <h5>{{ payment.receivable.description }}</h5>
                </Col>
                <Col span="5" offset="1" style="text-align:right">
                    <Tag type="border" color="blue"> {{ payment.amount | numberFormatted }} </Tag>
                </Col>
                <Col span="2"  style="text-align:right">
                    <Button 
                        type="success" 
                        @click="onSelectedPayment()" 
                        size="small"  >
                            <span>Select</span>
                    </Button>                
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
export default {    
    props: {
        payment: Object
    },
    data: () => ({

    }),  
    methods: {
      onSelectedPayment: function(){
        this.$emit('on-selected-payment', this.payment)
      },
    },

  watch: {},

  created() {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// PaymentRow.vue?f4062bb0